import React from 'react';
import {HashRouter,Route,Switch} from 'react-router-dom';
import Daily from './Daily';
import Month from './Month';
import DailyYL from './DailyYL';
import MonthYL from './MonthYL';

const BasicRoute =() => (
    <HashRouter>
      <Switch>
          <Route exact path="/" component={Daily} key="daily"/>
          <Route path="/month" component={Month} key="month"/>
          <Route exact path="/yl" component={DailyYL} key="daily-yl"/>
          <Route path="/monthyl" component={MonthYL} key="month-yl"/>

      </Switch>
    </HashRouter>
);

export default BasicRoute;
